import { IComponentOptions, IController } from "angular";
import { GtmhubController } from "@gtmhub/core";
import { IModalComponent } from "@gtmhub/core/routing";
import { unique } from "@gtmhub/util";
import { CreateCommentDTO } from "@webapp/comments";
import { OkrStatus } from "@webapp/okrs/goals/models/goal-status.models";
import { CloseOkrService, addPrefixToCommentText } from "../close-okr.service";
import { IOKRModalIndicators } from "../models";

export type CloseOkrBindings = {
  goalId: string;
  goalName: string;
  selectedStatus: OkrStatus;
  oldStatus: OkrStatus;
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ICloseOkrCtrlBindings extends IModalComponent<CloseOkrBindings> {}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CloseOkrCtrl extends ICloseOkrCtrlBindings {}
export class CloseOkrCtrl extends GtmhubController implements IController {
  private goalId: string;
  goalName: string;
  selectedStatus: OkrStatus;
  reason: string;
  comment: CreateCommentDTO;
  indicators: IOKRModalIndicators;

  static $inject = ["CloseOkrService"];
  constructor(private closeOkrService: CloseOkrService) {
    super();
  }
  $onInit(): void {
    this.indicators = {};
    this.goalId = this.resolve.goalId;
    this.goalName = this.resolve.goalName;
    this.selectedStatus = this.resolve.selectedStatus;
    this.comment = this.closeOkrService.initComment({ targetId: this.goalId, targetTitle: this.goalName, targetType: "goal" });
  }

  onCommentMentionsChanged(mentions: string[]): void {
    this.comment.mentioned = unique(mentions);
  }

  onCloseOkr(): void {
    this.indicators.changingState = { progress: true };

    this.closeOkrService
      .closeOkr({ goalId: this.goalId, selectedStatus: this.selectedStatus, reason: this.reason })
      .then(() => {
        delete this.indicators.changingState;
        const commentAdded = this.showComment() && !!this.comment.text;
        this.closeOkrService.trackGoalClosedStatusChange({
          new_state: this.selectedStatus,
          old_state: this.resolve.oldStatus,
          comment_posted: commentAdded,
          reason: this.reason,
        });
        if (commentAdded) {
          this.closeOkrService.postComment({
            indicators: this.indicators,
            comment: addPrefixToCommentText(this.comment, this.selectedStatus),
            targetId: this.goalId,
            targetType: "goal",
            callback: this.close,
          });
        } else {
          this.close();
        }
      })
      .catch((error) => {
        this.indicators.changingState = { error };
      });
  }

  isButtonDisabled(): boolean {
    return (!this.reason && this.selectedStatus === "abandoned") || !!this.indicators.changingState || !!this.indicators.creatingComment;
  }

  showComment(): boolean {
    return this.selectedStatus === "achieved" || (this.selectedStatus === "abandoned" && this.reason === "None of the above");
  }
}

export const CloseOkrComponent: IComponentOptions = {
  controller: CloseOkrCtrl,
  template: require("./close-okr.html"),
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
};
